import FunctionalDiagramEdit from '../../../../components/vehicle/functional_diagram/edit_mapping'
import FunctionalDiagramEditStore from '../../../../components/vehicle/functional_diagram/edit_mapping/context/context'

const FunctionalDiagramEditPage = () => {
  return (
    <FunctionalDiagramEditStore>
      <FunctionalDiagramEdit />
    </FunctionalDiagramEditStore>
  )
}

export default FunctionalDiagramEditPage
